import { createContext, useContext, useState, useEffect } from 'react'

const AuthContext = createContext(null)
const APP_PASSWORD = process.env.REACT_APP_APP_PASSWORD || 'leclair2026'
const SESSION_KEY = 'gl_session'

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)

  useEffect(() => {
    const saved = sessionStorage.getItem(SESSION_KEY)
    if (saved) {
      try { setUser(JSON.parse(saved)) } catch {}
    }
  }, [])

  function login(password) {
    if (password !== APP_PASSWORD) return false
    const u = { label: 'Groupe Leclair', isAdmin: true }
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(u))
    setUser(u)
    return true
  }

  function logout() {
    sessionStorage.removeItem(SESSION_KEY)
    setUser(null)
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}